import React from 'react';
import PropTypes from 'prop-types';
import { FunctionField } from 'react-admin';

const BooleanIntegerField = ({ source, ...props }) => (
  <FunctionField {...props} render={record => (record[source] === 1 ? 'Yes' : 'No')} />
);

BooleanIntegerField.propTypes = {
  source: PropTypes.string.isRequired,
  addLabel: PropTypes.bool,
};

BooleanIntegerField.defaultProps = {
  addLabel: true,
};

export default BooleanIntegerField;



// WEBPACK FOOTER //
// ./src/fields/BooleanIntegerField.jsx